/** Multi-account session limits (#168). */
export const MAX_ACCOUNTS = 5;
export const ACCOUNT_CAP_MESSAGE = `You can be signed in to at most ${MAX_ACCOUNTS} accounts. Sign out of one to add another.`;
